import React, { useState, useEffect, useRef } from "react";
import { Container, Card, ListGroup, InputGroup, Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import NavBar from './NavBar';
import Fuse from "fuse.js";
import { FaRobot, FaUser } from "react-icons/fa"; // Import robot and user icons from react-icons

function Chatbot({ asset, onClose, onRefresh }) {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showCategories, setShowCategories] = useState(true); // State untuk menampilkan kategori
  const [showTimeoutModal, setShowTimeoutModal] = useState(false); // Timeout modal state
  const [isRegistered, setIsRegistered] = useState(false); // State for registration status
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSessionActive, setIsSessionActive] = useState(true); // State to manage session timeout

  const messageContainerRef = useRef(null);
  const inactivityTimeoutRef = useRef(null);

  const categories = [
    "Program Keluarga Berencanass",
    "Kesehatan Reproduksi",
    "Kependudukan",
    "Layanan dan Informasi Lainnya"
  ];

  const handleCategorySelection = (category) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { text: `Anda memilih kategori: ${category}`, sender: "bot" },
    ]);
    setShowCategories(false); // Sembunyikan kategori setelah dipilih
  };

  const fuse = new Fuse([], {
    keys: ["question"],
    threshold: 0.4,
  });

  const handleSendMessage = () => {
    if (!userInput.trim()) return;

    setMessages([...messages, { text: userInput, sender: "user" }]);
    setIsLoading(true);

    axios
      .get("http://localhost:4000/api/master/project/faq")
      .then((response) => {
        const chatData = response.data;
        fuse.setCollection(chatData);
        const result = fuse.search(userInput);
        const foundResponse = result.length > 0 ? result[0].item.response : null;

        setTimeout(() => {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              text: foundResponse ? foundResponse : "Maaf, Pertanyaan Anda belum bisa Kami Jawab.",
              sender: "bot",
            },
          ]);
          setIsLoading(false);
          setUserInput("");
        }, 2000);
      })
      .catch((error) => {
        console.error("Error fetching chat data:", error);
        setIsLoading(false);
      });

    resetInactivityTimer();
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (email && password) {
      setIsRegistered(true);
      setMessages([
        {
          text: "Registrasi berhasil! Selamat datang di layanan chatbot BKKBN!",
          sender: "bot",
        },
      ]);

      // Start session timeout after registration
      resetInactivityTimer();
    } else {
      setMessages([
        {
          text: "Mohon isi email dan password yang valid.",
          sender: "bot",
        },
      ]);
    }
  };

  const resetInactivityTimer = () => {
    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }
    inactivityTimeoutRef.current = setTimeout(() => {
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: "Your session has been idle for 5 minutes. Would you like to continue?", sender: "bot" },
      ]);
      setShowTimeoutModal(true);
    }, 1 * 60 * 1000); // 5 minutes timeout
  };

  const handleTimeoutClose = (continueChat) => {
    setShowTimeoutModal(false);
    if (continueChat) {
      resetInactivityTimer(); // Reset timer if user wants to continue
    } else {
      // End the session and return to registration
      setIsSessionActive(false);
      setMessages([
        {
          text: "Session ended. Please log in again.",
          sender: "bot",
        },
      ]);
      setTimeout(() => {
        setIsRegistered(false); // Reset registration state
        setMessages([]); // Clear the chat history
      }, 2000); // Wait a moment before resetting to allow the message to be seen
    }
  };

  useEffect(() => {
    if (!isSessionActive) {
      setIsRegistered(false); // Reset registration when session ends
      setMessages([]); // Clear the messages when session ends
    } else if (isRegistered) {
      setMessages([
        {
          text: "Selamat datang di layanan chatbot BKKBN! Kami siap membantu Anda dengan informasi seputar program keluarga berencana, kesehatan reproduksi, dan kependudukan. Apa yang bisa kami bantu hari ini?",
          sender: "bot",
        },
      ]);
    }
  }, [isRegistered, isSessionActive]);

  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
    resetInactivityTimer();
  }, [messages]);

  document.title = "AI Report";

  return (
    <Container fluid className="d-flex justify-content-center align-items-center" style={styles.container}>
      <div>
        <NavBar />
      </div>
      <Card style={styles.card}>
        <Card.Header style={styles.cardHeader}>
          <h4><FaRobot style={styles.icon} /> ChatBot</h4> {/* Using robot icon here */}
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush" style={styles.messageContainer} ref={messageContainerRef}>
            {!isRegistered && isSessionActive && (
              <ListGroup.Item>
                <strong>Registrasi</strong>
                <Form onSubmit={handleRegister}>
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit">
                    Register
                  </Button>
                </Form>
              </ListGroup.Item>
            )}
            {messages.map((msg, index) => (
              <ListGroup.Item
                key={index}
                style={{
                  ...styles.message,
                  ...(msg.sender === "user" ? styles.userMessage : styles.botMessage),
                }}
              >
                <strong>
                  {msg.sender === "bot" ? <FaRobot style={styles.icon} /> : <FaUser style={styles.icon} />}
                  {msg.sender === "bot" ? "BKKBN" : "You"}:
                </strong>
                {" "}
                <span dangerouslySetInnerHTML={{ __html: msg.text }} />
              </ListGroup.Item>
            ))}
            {showCategories && isRegistered && isSessionActive && (
              <ListGroup.Item style={styles.categoryList}>
                <strong>Pilih kategori:</strong>
                <ul>
                  {categories.map((category, index) => (
                    <li key={index}>
                      <Button
                        variant="link"
                        onClick={() => handleCategorySelection(category)}
                        style={styles.categoryButton}
                      >
                        {category}
                      </Button>
                    </li>
                  ))}
                </ul>
              </ListGroup.Item>
            )}
            {isLoading && (
              <ListGroup.Item className="text-center">
                <span className="typing-animation-pulse">BKKBN is typing</span>
              </ListGroup.Item>
            )}
          </ListGroup>
          {isRegistered && isSessionActive && (
            <InputGroup style={styles.inputGroup}>
              <Form.Control
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Ketik Pertanyaan Anda..."
                style={styles.inputField}
                disabled={showCategories}
              />
              <Button variant="primary" onClick={handleSendMessage} style={styles.sendButton} disabled={showCategories}>
                Send
              </Button>
            </InputGroup>
          )}
        </Card.Body>
      </Card>

      {/* Timeout Modal */}
      <Modal show={showTimeoutModal} onHide={() => handleTimeoutClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sesi Telah Berakhir</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your session has been idle for 5 minutes. Would you like to continue?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleTimeoutClose(false)}>
            End Chat
          </Button>
          <Button variant="primary" onClick={() => handleTimeoutClose(true)}>
            Continue Chat
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

const styles = {
  container: {
    paddingTop: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "1180px",
    height: "800px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  cardHeader: {
    backgroundColor: "#fff",
    color: "black",
    fontSize: "20px",
  },
  messageContainer: {
    height: "650px",
    overflowY: "auto",
  },
  categoryList: {
    paddingTop: "10px",
  },
  categoryButton: {
    color: "#007bff",
    textDecoration: "none",
  },
  message: {
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "10px",
  },
  botMessage: {
    backgroundColor: "#f1f1f1",
    textAlign: "left",
  },
  userMessage: {
    backgroundColor: "#e0f7fa",
    textAlign: "right",
  },
  inputGroup: {
    marginTop: "10px",
  },
  inputField: {
    borderRadius: "10px",
    paddingLeft: "15px",
    marginRight: "5px",
  },
  sendButton: {
    borderRadius: "10px",
  },
  icon: {
    marginRight: "8px",
  },
};

export default Chatbot;
